import { toast } from 'sonner';

export default toast;
